(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-dd-b2b-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if(window.__ddb2b) return; window.__ddb2b=1;
    var R = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function arm(){
      [].forEach.call(document.querySelectorAll('.ddb2b'), function(s){ s.classList.add('ddb2b-armed'); });
      var rev = [].slice.call(document.querySelectorAll('[data-ddb2b-reveal]'));
      if(!('IntersectionObserver' in window) || R){ rev.forEach(function(e){ e.classList.add('is-in'); }); }
      else {
        var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin:'0px 0px -8% 0px', threshold:.12 });
        rev.forEach(function(e){ io.observe(e); });
      }
      var nums = [].slice.call(document.querySelectorAll('[data-ddb2b-count]'));
      function run(el){
        var raw = el.getAttribute('data-ddb2b-count'); var m = raw.match(/\d+/);
        if(!m || R){ el.textContent = raw; return; }
        var target = parseInt(m[0],10), pre = raw.slice(0,m.index), suf = raw.slice(m.index+m[0].length), t0=null, d=1500;
        function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/d); var e=1-Math.pow(1-p,3); el.textContent=pre+Math.round(target*e)+suf; if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      }
      if(!('IntersectionObserver' in window)){ nums.forEach(run); }
      else { var io2 = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ run(x.target); io2.unobserve(x.target); } }); }, { threshold:.5 }); nums.forEach(function(e){ io2.observe(e); }); }
    }
    if(document.readyState !== 'loading') arm(); else document.addEventListener('DOMContentLoaded', arm);
    document.addEventListener('shopify:section:load', function(){ window.__ddb2b=0; arm(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
